<div class="card bg-light shadow-sm" [hidden]="!visibleFilters">
    <div class="card-body">
        <form name="frmTakapaFilter" #ngFrmTakapaFilter="ngForm">
            <div class="row">
                <div class="col-2 d-flex align-items-center">
                    <div class="w-50 align-items-center">
                        <label class="control-label">Période de</label>
                        <div class="d-flex flex-row justify-content-start flex-wrap full-width">
                            <div>
                                <label class="control-label">Mois</label>
                                <input type="text" name="Mm_De" minlength="2" maxlength="2" class="form-control"
                                    required [(ngModel)]="filters.MmDe" placeholder="MM" style="width:30px;" />
                            </div>
                            <div>
                                <label class="control-label ml-1">Annee</label>
                                <input type="text" name="Aaaa_De" minlength="4" maxlength="4" class="form-control"
                                    required [(ngModel)]="filters.AaaaDe" placeholder="AAAA" style="width:40px;" />
                            </div>
                        </div>
                    </div>
                    <div class="w-50 align-items-center pl-2">
                        <label class="control-label">Période à</label>
                        <div class="d-flex flex-row justify-content-start flex-wrap full-width">
                            <div>
                                <label class="control-label">Mois</label>
                                <input type="text" name="Mm_A" minlength="2" maxlength="2" class="form-control" required
                                    [(ngModel)]="filters.MmA" placeholder="MM" style="width:30px;" />
                            </div>
                            <div>
                                <label class="control-label ml-1">Annee</label>
                                <input type="text" name="Aaaa_A" minlength="4" maxlength="4" class="form-control"
                                    required [(ngModel)]="filters.AaaaA" placeholder="AAAA" style="width:40px;" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-2 d-flex flex-column justify-content-center align-items-stretch">
                    <label class="control-label">Axe 1</label>
                    <kendo-combobox class="form-control" [filterable]="true" textField="PolLib" valueField="PolCod"
                        [valuePrimitive]="true" name="Poles" [data]="lstPoles" [(ngModel)]="this.filters.PolCod"
                        style="width:100%;" #cboPoles [disabled]="TopPerimetre"
                        (filterChange)="onPolesFilterChanged($event)" (valueChange)="onAxeChanged($event,'PolCod')">
                        <ng-template kendoMultiSelectTagTemplate let-dataItem>
                            {{dataItem.PolLib}}
                        </ng-template>
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <div style="width:100%;"
                                [innerHTML]="sharedDataSvc.highlightSearch(dataItem.PolLib,poleSearchMask)">
                            </div>
                        </ng-template>
                    </kendo-combobox>
                </div>
                <div class="col-2 d-flex flex-column justify-content-center align-items-stretch">
                    <label class="control-label">Axe 2</label>
                    <kendo-combobox class="form-control" [filterable]="true" textField="RegLib" valueField="RegCod"
                        [valuePrimitive]="true" name="Regs" [data]="lstRegs" style="width:100%;" #cboRegs
                        [disabled]="TopPerimetre" [(ngModel)]="filters.RegCod"
                        (filterChange)="onRegsFilterChanged($event)" (valueChange)="onAxeChanged($event,'RegCod')">
                        <ng-template kendoMultiSelectTagTemplate let-dataItem>
                            {{dataItem.RegLib}}
                        </ng-template>
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <div style="width:100%;"
                                [innerHTML]="sharedDataSvc.highlightSearch(dataItem.RegLib,regSearchMask)">
                            </div>
                        </ng-template>
                    </kendo-combobox>
                </div>
                <div class="col-3 d-flex flex-column justify-content-center align-items-stretch">
                    <label class="control-label">Etablissement</label>
                    <kendo-multiselect class="form-control" [filterable]="true" textField="EtbLib" valueField="EtbCod"
                        [valuePrimitive]="true" name="Etbs" [data]="lstEtbs" style="width:100%;"
                        [(ngModel)]="filters.EtbCods" (filterChange)="onEtbsFilterChanged($event)"
                        [disabled]="TopPerimetre" #cboEtbs>
                        <ng-template kendoMultiSelectTagTemplate let-dataItem>
                            {{displayEtb(dataItem.EtbCod)}}
                        </ng-template>
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <div style="width:100%;"
                                [innerHTML]="sharedDataSvc.highlightSearch(displayEtb(dataItem.EtbCod),etbSearchMask)">
                            </div>
                        </ng-template>
                    </kendo-multiselect>
                </div>
                <div class="col-3 d-flex flex-column justify-content-center align-items-stretch">
                    <label class="control-label text-wrap">Montant de commandes</label>
                    <div class="d-flex flex-row justify-content-start align-items-center">                        
                        <div class="d-flex">
                            <label class="control-label">Mini</label>
                            <input type="number" class="form-control text-left" name="mntMini" [(ngModel)]="filters.MntMin" [max]="filters.MntMax||0" style="width:80px;">
                            <label class="control-label text-left">€</label>
                        </div>
                        <div class="ml-2 d-flex">
                            <label class="control-label">Maxi</label>
                            <input type="number" class="form-control text-left" name="mntMaxi" [min]="filters.MntMin||0" [(ngModel)]="filters.MntMax" style="width:80px;">
                            <label class="control-label text-left">€</label>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-content-left align-items-center mt-1">
                        <div class="d-flex align-items-center">
                            <input type="checkbox" kendoCheckBox name="chkPerimetre" [(ngModel)]="TopPerimetre">
                            <label class="control-label pl-1">Périmètre</label>
                        </div>

                        <div class="d-flex align-items-center">
                            <input type="checkbox" kendoCheckBox name="chkMultiDR" [(ngModel)]="filters.TopDetailParEtb">
                            <label class="control-label pl-1">Détail par établissement</label>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<div class="row mt-2">
    <div class="col text-center">
        <button class="btn btn-sm btn-primary float-left" type="button" (click)="toggleDisplayFilters()">
            <span [hidden]="visibleFilters">
                <paflabel lblCod="Filtres_de_recherche"></paflabel>&nbsp;<i class="fas fa-search"></i>
            </span>
            <span [hidden]="!visibleFilters">
                <paflabel lblCod="Masquer_les_filtres"></paflabel>&nbsp;<i class="far fa-caret-square-up"></i>
            </span>
        </button>
        <button class="btn btn-sm btn-primary mx-2" type="commit" (click)="search()"><i
                class="fas fa-search mr-1"></i>Rechercher</button>
        <button class="btn btn-sm btn-success mx-2" type="button" (click)="exportExcel()"><i
                class="far fa-file-excel mr-1"></i>Exporter</button>
        <button class="btn btn-sm btn-warning mx-2" type="button" (click)="reinit()"><i
                class="fas fa-ban mr-1"></i>Réinitialiser filtres</button>
        <button class="btn btn-sm btn-danger mx-2" type="button" (click)="reinitAll()"><i
                class="fas fa-ban mr-1"></i>Réinitialiser tout</button>
    </div>
</div>

<div class="card mt-1">
    <div class="card-body">
                <kendo-grid class="takapa-grid-results" id="grid" #financesCmdsGrid [data]="gridData"
                    [pageSize]="state.take" 
                    [resizable]="true" 
                    [skip]="state.skip" 
                    [sort]="state.sort"
                    [filter]="state.filter" 
                    [sortable]="false" 
                    [pageable]="gridPageableSettings" 
                    [filterable]="'menu'"
                    [groupable]="false"
                    [group]="state.group"
                    [height]="gridHeight" 
                    [reorderable]="false" 
                    (filterChange)="filterChange($event)"
                    (dataStateChange)="dataStateChange($event)">
                    <kendo-grid-messages filterIsFalse="Non&nbsp;&nbsp;" filterIsTrue="Oui&nbsp;&nbsp;">
                    </kendo-grid-messages>
                    <kendo-grid-column *ngIf="gridTopDetailParEtb" field="displayEtb" title="Etablissement" [width]="200">
                    </kendo-grid-column>


                    <kendo-grid-column field="Mois_Clair" title="Mois" [width]="80"></kendo-grid-column>

                    <kendo-grid-column field="Nb_Commandes_Mois" title="Nb cdes par mois"
                        class="text-center text-currency" filter="numeric" [width]="160"> </kendo-grid-column>
                    <kendo-grid-column field="Nb_Commandes_Cumule" title="Nb cdes cumulées"
                        class="text-center text-currency" filter="numeric" [width]="160"> </kendo-grid-column>


                    <kendo-grid-column field="Mt_Commandes_Mois" title="Montant cdes par mois"
                        class="text-right text-currency" filter="numeric" format="{0:c}"
                        [width]="160"></kendo-grid-column>
                    <kendo-grid-column field="Mt_Commandes_Cumule" title="Montant cdes cumulées"
                        class="text-right text-currency" filter="numeric" format="{0:c}"
                        [width]="160"></kendo-grid-column>


                </kendo-grid>

                <kendo-excelexport [fileName]="excelExportFileName" [filterable]="true" #excelexport>
                    <kendo-excelexport-column *ngIf="gridTopDetailParEtb" field="displayEtb" title="Etablissement"></kendo-excelexport-column>
                    <kendo-excelexport-column field="Mois_Clair" title="Mois"></kendo-excelexport-column>
                    <kendo-excelexport-column field="Nb_Commandes_Mois" title="Nb cdes par mois"
                        filter="numeric"></kendo-excelexport-column>
                    <kendo-excelexport-column field="Nb_Commandes_Cumule" title="Nb cdes cumulées"
                        filter="numeric"></kendo-excelexport-column>
                    <kendo-excelexport-column field="Mt_Commandes_Mois" title="Montant cdes par mois"
                        [cellOptions]="{ format: '#,##0.00 €' }" class="text-right" filter="numeric"
                        format="{0:c}"></kendo-excelexport-column>
                    <kendo-excelexport-column field="Mt_Commandes_Cumule" title="Montant cdes cumulées"
                        [cellOptions]="{ format: '#,##0.00 €' }" class="text-right" filter="numeric"
                        format="{0:c}"></kendo-excelexport-column>

                </kendo-excelexport>



    </div>
</div>

<pre *ngIf="sharedDataSvc.debug">Filtres : {{filters | json}}</pre>